var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var FieldSection = /** @class */ (function () {
            function FieldSection() {
                this.templateUrl = './app/views/directives/inputForm/fieldSection.html';
                this.restrict = 'E';
                this.controller = ['$scope', 'ModalService', 'formSectionService', 'formService', 'deleteService', FieldSectionController];
                this.controllerAs = 'controller';
                this.scope = {
                    isConfigureMode: "=",
                    isEditMode: "=",
                    showSlider: "=",
                    field: "=",
                    formSection: "=",
                    formData: "=",
                    isReadOnly: "=",
                    fieldBlurred: "=",
                    processConfigurationId: "=",
                    processConfiguration: "=",
                    formDataId: "=",
                    formId: "=",
                    processId: "=",
                    process: "=",
                    parentFormId: "=",
                    step: "=",
                    form: "="
                };
            }
            FieldSection.prototype.link = function ($scope, element, attrs) {
            };
            return FieldSection;
        }());
        directives.FieldSection = FieldSection;
        var FieldSectionModel = /** @class */ (function (_super) {
            __extends(FieldSectionModel, _super);
            function FieldSectionModel($scope, modalService, formSectionService, formService, deleteService) {
                return _super.call(this, $scope, modalService, formSectionService, formService, deleteService) || this;
            }
            FieldSectionModel.prototype.join = function (field, group) {
                field.isSplitRow = false;
                this.formSectionService.splitFields(group);
                this.formService.saveAllChanges();
            };
            FieldSectionModel.prototype.split = function (field, group) {
                field.isSplitRow = true;
                this.formSectionService.splitFields(group);
                this.formService.saveAllChanges();
            };
            return FieldSectionModel;
        }(directives.FieldBaseModel));
        directives.FieldSectionModel = FieldSectionModel;
        var FieldSectionController = /** @class */ (function () {
            function FieldSectionController($scope, modalService, formSectionService, formService, deleteService) {
                this.modalService = modalService;
                this.formSectionService = formSectionService;
                this.formService = formService;
                this.deleteService = deleteService;
                $scope.model = new FieldSectionModel($scope, modalService, formSectionService, formService, deleteService);
            }
            return FieldSectionController;
        }());
        directives.FieldSectionController = FieldSectionController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('FieldSection', []);
